import { TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutCarriersForAssignment } from "./autogen/AutogenLayoutCarriersForAssignment";

export class CarriersForAssignment extends AutogenLayoutCarriersForAssignment {

    tableCarriersForAssignmentOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        if (tableRow.index > 0) {
            tableRow.table.rows[tableRow.index - 1].borderBottomWidth = 1;
        }
    }

}
